import { render, staticRenderFns } from "./ViInput.vue?vue&type=template&id=cafd2820&"
import script from "./ViInput.vue?vue&type=script&lang=js&"
export * from "./ViInput.vue?vue&type=script&lang=js&"
import style0 from "./ViInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports